var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 43,
    viewBox: "0 0 40 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 22,
    x: 12.5,
    y: 1.5,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M4.67828101,9.5 L1.65097109,41.0195055 L38.3502452,41.0195055 L35.3462715,9.5 L4.67828101,9.5 Z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(12 7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5,0.5 L0.5,5.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5,0.5 L0.5,5.5",
    transform: "translate(16)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBag);
export default __webpack_public_path__ + "static/media/icon-bag.18709dc7.svg";
export { ForwardRef as ReactComponent };